// angular
import { Injectable } from '@angular/core';

// rxjs
import { Observable } from 'rxjs';

/**
 *  Interface the deactivate guard must implement.
 */
export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

/**
 * Guard used to show warning message when user is navigating away from
 * the screen after making changes.
 */
@Injectable()
export class CanDeactivateGuard {
  /**
   * Determines if the component can be deactivated or not.
   * @param component
   */
  canDeactivate(component: CanComponentDeactivate) {
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
